<template>
    <div class="c-composable-usecases">
        <div
            v-if="content.custom"
            class="c-composable-usecases__title"
        >
            <h2 class="mb-3">
                {{ content.custom.field4 }}
            </h2>
        </div>

        <div
            v-if="$mq === 'lg' || $mq === 'xlg'"
            class="c-composable-usecases__content"
        >
            <y-row class="justify-content-center">
                <y-col
                    v-for="(album, index) in content.albums.filter(g=> g.group === 'album2')"
                    :key="`solutions-${index}`"
                    sm="12"
                    md="6"
                    lg="4"
                >
                    <div class="c-composable-usecases__content__card">
                        <div class="c-composable-usecases__content__card__image">
                            <div class="img">
                                <img
                                    :src="album.link"
                                    :alt="album.title"
                                >
                            </div>
                            <div class="index-solution">
                                <span>
                                    {{ digits(((index + 1) < 10 ? 0 : '').toString() + (index + 1).toString(), $i18n.locale) }}
                                </span>
                            </div>
                        </div>
                        <div class="c-composable-usecases__content__card__title">
                            <div class="title">
                                <h3>
                                    {{ album.title }}
                                </h3>
                            </div>
                        </div>
                        <div
                            v-if="album.description"
                            class="c-composable-usecases__content__card__text mt-3"
                        >
                            <p
                                v-for="(text, textCount) in splitAndRemoveNewlines(album.description)"
                                :key="`solutions-${index}-${textCount}`"
                            >
                                {{ text }}
                            </p>
                        </div>
                    </div>
                </y-col>
            </y-row>
        </div>

        <div
            v-else
            class="c-composable-usecases__slide-show-wrapper"
        >
            <y-slideshow
                ref="Slideshow"
                height="auto"
                slides-per-view="1.2"
                pagination="1"
                autoplay
            >
                <y-slide
                    v-for="(album, index) in content.albums.filter(g=> g.group === 'album2')"
                    :key="`responsive-solutions-${index}`"
                >
                    <div class="pa-4">
                        <div class="c-composable-usecases__content__card">
                            <div class="c-composable-usecases__content__card__image">
                                <div class="img">
                                    <img
                                        :src="album.link"
                                        :alt="album.title"
                                    >
                                </div>
                                <div class="index-solution">
                                    <span>
                                        {{ digits(((index + 1) < 10 ? 0 : '').toString() + (index + 1).toString(), $i18n.locale) }}
                                    </span>
                                </div>
                            </div>
                            <div class="c-composable-usecases__content__card__title">
                                <div class="title">
                                    <span>
                                        {{ album.title }}
                                    </span>
                                </div>
                            </div>
                            <div
                                v-if="album.description"
                                class="c-composable-usecases__content__card__text"
                            >
                                <p
                                    v-for="(text, textCount) in splitAndRemoveNewlines(album.description)"
                                    :key="`solutions-${index}-${textCount}`"
                                >
                                    {{ text }}
                                </p>
                            </div>
                        </div>
                    </div>
                </y-slide>
            </y-slideshow>
        </div>

        <div
            v-if="content.custom && content.custom['field6']"
            class="d-f justify-content-center align-items-center"
        >
            <y-button
                :tag="isLink(content.custom['field6']) ? 'a' : 'router-link'"
                color="primary"
                class="start-building-btn"
                :href="content.custom['field6']"
                :to="content.custom['field6']"
            >
                {{ content.custom['field5'] }}
            </y-button>
        </div>
    </div>
</template>

<script>
    import { YSlide, YSlideshow } from '@groot-components/all';
    import { digits } from '@groot-nodes/helpers/number';

    import { isLink } from '@/helpers/helpers';

    export default {
        name: 'Solutions',

        components: { YSlide, YSlideshow },
        
        props: {
            content: Object,
        },
        methods: {
            digits,
            isLink,
            /**
             * Split the string into an array using "\n" as the separator
             *
             * @param {string} text
             * @returns {*[]}
             */
            splitAndRemoveNewlines(text) {
                return text.split('\\n');
            },
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
